module.exports = __webpack_public_path__ + "img/rei-meta.0459b968.jpg";